import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { LIBRARY_URL } from "@/config/api";
import IframeScreen from "../IframeScreen/IframeScreen";
import { useAppSelector } from "@/redux/store";

const DesignFileScreen = () => {
  const location = useLocation();
  const { libraryId } = useAppSelector((state) => state.auth);
  const [url, setUrl] = useState<string>("");

  useEffect(() => {
    setUrl(`${LIBRARY_URL}${getCallbackUrl()}`);
  }, [location.pathname, libraryId]);

  const getCallbackUrl = () => {
    return `/taga-library/personal/${libraryId}`;
  };

  return <IframeScreen url={url} />;
};

export default DesignFileScreen;
